var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time_in_programm_card"},[_c('div',{staticClass:"time_in_programm_date"},[_vm._v(" "+_vm._s(_vm.day)+" ")]),_c('div',{staticClass:"time_in_programm"},[_vm._v(_vm._s(_vm.timeInTheProgram(_vm.ptime)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }